import { __extends } from "tslib";
import { deepMix } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';

var Funnel =
/** @class */
function (_super) {
  __extends(Funnel, _super);

  function Funnel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'funnel';
    return _this;
  }
  /**
   * 获取 漏斗图 默认配置项
   */


  Funnel.prototype.getDefaultOptions = function (options) {
    var xField = options.xField,
        yField = options.yField,
        dynamicHeight = options.dynamicHeight,
        compareField = options.compareField;
    var additionalOption = {};

    if (dynamicHeight) {
      additionalOption = {
        tooltip: {
          itemTpl: '<li class="g2-tooltip-list-item" data-index={index}>' + '<span style="background-color:{color};" class="g2-tooltip-marker"></span>' + ("<span class=\"g2-tooltip-name\">{" + xField + "}</span>") + ("<span class=\"g2-tooltip-value\" style=\"display: inline-block; float: right; margin-left: 30px;\">{" + yField + "}</span></li>")
        }
      };
    } else if (compareField) {
      additionalOption = {
        appendPadding: [50, 50, 0, 50],
        label: {
          callback: function callback(xField, yField) {
            return {
              content: "" + yField
            };
          }
        }
      };
    }

    return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
      // annotation 无法自适应 chart，先用 appendPadding hack, 随后看看如何自适应
      appendPadding: [0, 50],
      label: {
        offset: 0,
        position: 'middle',
        // layout: {
        //   type: 'limit-in-shape',
        // },
        style: {
          fill: '#fff',
          fontSize: 12
        },
        callback: function callback(xField, yField) {
          return {
            content: xField + " " + yField
          };
        }
      },
      tooltip: {
        showTitle: false,
        showMarkers: false,
        shared: false
      },
      conversionTag: {
        offsetX: 10,
        offsetY: 0,
        style: {},
        formatter: function formatter(datum) {
          return "\u8F6C\u5316\u7387" + datum.$$percentage$$ * 100 + "%";
        }
      }
    }, additionalOption);
  };
  /**
   * 获取 漏斗图 的适配器
   */


  Funnel.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return Funnel;
}(Plot);

export { Funnel };